<template>
  <div @click="openModal">
    <!-- 弹框 -->
    <el-input
      :placeholder="placeholder"
      :value="name || value"
      readonly
      :disabled="disabled"
    ></el-input>
    <SelectConfig ref="selectConfig" @onGetSelect="onGetSelect" />
  </div>
</template>

<script>
import SelectConfig from '@/found/components/select_org_cus_ter/select_config.vue';

export default {
  name: 'NoticeManageTableForm',
  components: {
    SelectConfig,
  },
  props: {
    value: String,
    placeholder: String,
    disabled: Boolean,
    parentCode: String,
    functionCode: String,
    paramsObj: Object,
    infoKey: String,
    infoCallback: Function,
  },
  data() {
    return {
      modalConfig: {}, // 弹框信息
      name: '',
    };
  },
  methods: {
    onGetSelect(val) {
      this.name = val[0].productCode;
      this.$emit('change', val[0]);
    },
    // 打开弹窗
    openModal() {
      const params = {
        ...this.paramsObj,
      };
      this.$refs.selectConfig.openSelectModal(params);
    },
  },
};
</script>

<style lang="less" scoped>
</style>
